import { render } from "./SelectTasting.vue?vue&type=template&id=ed213e9a"
import script from "./SelectTasting.vue?vue&type=script&lang=js"
export * from "./SelectTasting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__